export const colors = {
  // Primary Colors
  primary100: "#FDEDEB",
  primary200: "#FBDDD9",
  primary500: "#EE4D37",

  success500: "#10B981",
  error500: "#EF4444",
  red700: "#973236",
  red100: "#F2D9D9",
  info100: "#C2D0F2",
  blue500: "#144CC7",

  // Add more colors as needed
  // secondary500: '#...',
  // secondary100: '#...',
  // secondary200: '#...',

  // Neutral colors
  white: "#FFFFFF",
  black: "#000000",

  gray100: "#E5E5E5",
  gray200: "#808080",
  gray600: "#8A8A8A",
};

export default colors;
